import { default as PrivacyPolicy } from "./privacy-policy-root";

export default PrivacyPolicy;
